export enum PERSONA {
  NEW = 1,
  BUILDER = 2,
  LEADER = 3,
  SILVER = 4,
  EMERALD = 5,
  DIAMOND = 6,
}

export enum PERSONA_V2 {
  NEW = 1,
  BUSINESS_BUILDER = 2,
  LEADER = 3,
}
